export default __webpack_public_path__ + "static/decorist-4-d-2fd1d65c82f98fb0e7b0ebe1db6963cc.webp";